export default {
  id: "38e02b46-4eba-4957-8d38-6709e155ab60",
  icon: "mdi-image",
  name: "imageMultipleChoice",
  title: "Image Multiple Choice",
  description: "A block multiple choice image"
}
